import React from 'react';
import './PostCard.css'
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faUser, faTag } from '@fortawesome/free-solid-svg-icons';
import { Post } from '../../types/types';

interface PostCardProps {
  post: Post;
}

const PostCard: React.FC<PostCardProps> = ({ post }) => {
  const date = new Date(post.date);
  const month = date.toLocaleString('default', { month: 'long' }); // "May"
  const day = date.getDate(); // 26
  let shortContent = post.content.slice(0, 300) + '...';
  shortContent = shortContent.replace(/\*/g, '');

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/totd/${post.slug}`, {state: { post } });
  };

  return (
    <div className="post-card" onClick={handleClick}>
      <h2>{post.title}</h2>
      {/* <span><span className='by'>By</span> {post.author}</span> */}
      {post.tags && post.tags.length > 0 && (
        <div className="post-tags">
          {post.tags.map((tag, index) => (
            <span key={index}><FontAwesomeIcon icon={faTag} /> {tag}</span>
          ))}
        </div>
      )}
      <div className="post-meta">
        <span className='post-date'><FontAwesomeIcon icon={faCalendarAlt} /> {month} {day}</span>
      </div>
      <p className='post-content'>
        {shortContent}
      </p>
      <span className="read-more">Read More</span>
    </div>
  );
};

export default PostCard;
